import styled from 'styled-components';

export const ActionButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 5px;
`;